module.exports = __webpack_public_path__ + "media/images/new-ui-images/pre-icon-4dd5f1c32043ff1add6a3505220135e8.svg";